import React from "react";
import { UploadOutlined, SearchOutlined } from "@ant-design/icons";
import { Flex, Typography, Button, Upload } from "antd";

function Uploader({ onChange, preImage, type, title, height, width, accept, hideText, dimensions, uploaderRef, id }) {
	return (
		<Upload.Dragger
			className={`initial-uploader ${type === "video" || title ? "initial-uploader-video" : ""}`}
			style={preImage ? { height: height, minHeight: height, width: width, padding: 8 } : hideText && dimensions}
			showUploadList={false}
			accept={accept}
			onChange={onChange}
			onDrop={onChange}
			action={() => {}}
			customRequest={() => {}}
			ref={uploaderRef}
			id={id}
		>
			{preImage ? (
				<img src={preImage} alt="pre" />
			) : (
				<Flex align="center" gap={4} vertical>
					<UploadOutlined style={{ fontSize: 40, color: "rgba(0, 0, 0, 0.65)" }} />
					{!hideText && (
						<>
							<Typography.Text strong>Click to upload or drag and drop</Typography.Text>
							<Typography.Text>Max. File Size: 3MB</Typography.Text>
							{(type === "video" || title) && <span>{title || "Upload Video"}</span>}
							<Button className="upload-btn" type="primary">
								<Flex align="center" gap={8}>
									<SearchOutlined />
									Browse File
								</Flex>
							</Button>
						</>
					)}
				</Flex>
			)}
		</Upload.Dragger>
	);
}

export default Uploader;
